module.exports = __webpack_public_path__ + "img/2@2x.fd9d8a6e.png";